module.exports = __webpack_public_path__ + "static/media/ic-nav-analysis-inactive.9189d198.svg";